import { reduce } from 'lodash';

import { TMappedObject, ValueOf } from 'types';

export const getFormattedFloatNumber = (value: string) => value && Number(value.replace(/[^\d.-]/g, ''));

export const getFormattedCurrency = (price?: number | string, withSign?: boolean) => {
  if (price || price === 0) {
    const value = Number(price);

    const currency = new Intl.NumberFormat('en-US', {
      ...(withSign && {
        style: 'currency',
        currency: 'USD',
      }),
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return currency.format(value);
  }

  return '';
};

export const formatToMilliseconds = (value: number, unit: 'mins' | 'hours' = 'mins') => {
  if (unit === 'mins') {
    return value * 60 * 1000;
  }

  return value * 60 * 60 * 1000;
};

export const getFormattedDataWithScores = <T extends Record<string, ValueOf<T>>>(data?: T) => {
  const dataWithScores = reduce<T, TMappedObject<T>>(
    data,
    (acc, value, key) => {
      if (['id', 'key'].includes(key)) {
        return acc;
      }

      if (key.includes('Score')) {
        acc[key] = 1;

        return acc;
      }

      acc[key] = value;
      acc[`${key}Score`] = 1;
      acc[`${key}OcrScore`] = 1;

      return acc;
    },
    {},
  );

  return dataWithScores as T;
};

export const getFormattedPercent = (value?: number) => {
  if (!value && value !== 0) {
    return '';
  }

  const val = String(value);

  if (val.includes('.')) {
    return `${Number(val).toFixed(2)}%`;
  }

  return `${val}%`;
};
